var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 8H10.6668C7.72131 8 5.3335 10.3878 5.3335 13.3333V14.6667M8.00016 25.3333H21.3335C24.279 25.3333 26.6668 22.9455 26.6668 20V18.6667M22.6668 12L25.724 8.94281C26.2447 8.42211 26.2447 7.57789 25.724 7.05719L22.6668 4M9.3335 21.3333L6.27631 24.3905C5.75561 24.9112 5.75561 25.7554 6.2763 26.2761L9.3335 29.3333",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.f41d9e43cc50cdaa32c445e5549ae1ee.svg";
export { ForwardRef as ReactComponent };